module.exports = __webpack_public_path__ + "img/绍兴百盛.4b81a0b9.png";